export default class ChangeText {
  change(element) {
    let show = $(element).data('show');
    let hide = $(element).data('hiden');
    let text_show = $(element).attr('is_client_show') == 'true' ? hide : show
    $(element).text(text_show)
  }
}